import React from "react"

export const Footer = () => {
  return (
    <>
      <footer>
        <p>Copyright © GOSTO . Powered by WidedBoukouba.</p>
      </footer>
    </>
  )
}
